import { Component, OnInit, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ContentfulService } from '../contentful/contentful.service';
import { CartStore } from '../cart/cart.store';
import { formatPhone as formatPhoneLabel, phoneHref as phoneTelHref } from '../contacts/phone';

interface ContactsFields {
  name: string;
  phones?: string[];
}

@Component({
  selector: 'app-header',
  imports: [RouterLink],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit {
  phones = signal<string[]>([]);
  readonly cart: CartStore;

  constructor(
    private readonly contentfulService: ContentfulService,
    cartStore: CartStore,
  ) {
    this.cart = cartStore;
  }

  ngOnInit(): void {
    this.contentfulService
      .getEntries<ContactsFields>({
        contentType: 'contacts',
        query: { 'fields.name': 'Roma' },
        limit: 1,
      })
      .subscribe({
        next: (res) => {
          const entry = res.items[0];
          if (entry) {
            this.phones.set((entry.fields['phones'] as string[] | undefined) ?? []);
          }
        },
      });
  }

  formatPhone(raw: string): string {
    return formatPhoneLabel(raw);
  }

  phoneHref(raw: string): string {
    return phoneTelHref(raw);
  }
}
